import store from '@/state/store';
import { handleError } from '../common';
import * as api from '@/api/profile';
import authenticationSlice, {
  ClientState,
  ImplicitProjectThumbnails,
  MembersSorting,
  ModelsSorting,
} from '@/state/authentication.slice';
import { ProjectsOrderBy } from '@/contracts';
import { localStorage, StorageKey } from '@bimdata/client';

const updateClientState = async (updates: Partial<ClientState>) => {
  try {
    const result = await api.setProfile({ clientState: updates });
    if (result) {
      if (result.clientState) {
        store.dispatch(authenticationSlice.actions.updateClientState(result.clientState as ClientState));
      }
    } else {
      store.dispatch(authenticationSlice.actions.updateClientState(updates));
      if (localStorage) {
        localStorage.set(StorageKey.ANON_CLIENT_STATE, store.getState().authentication.clientState);
      }
    }
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const setSetting = (name: string, value: unknown) => updateClientState({ settings: { [name]: value } });

export const saveProjectsListSettings = (orderBy: ProjectsOrderBy, isDesc: boolean) => updateClientState({
  projectsOrderBy: orderBy,
  projectsDescOrder: isDesc,
});

export const saveSidebarWidth = (width: number) => updateClientState({ sidebarWidth: width });

export const saveSelectedModels = (project: string, models: number[]) => updateClientState({ selectedModels: { [project]: models } });

export const saveExpandedSections = (project: string, sections: Record<string, boolean>) => updateClientState({
  expandedSections: {
    [project]: {
      ...store.getState().authentication.clientState.expandedSections[project],
      ...sections,
    }
  }
});

export const saveExpandedAttributeGroups = (project: string, groups: Record<string, boolean>) => updateClientState({
  expandedAttributeGroups: {
    [project]: {
      ...store.getState().authentication.clientState.expandedAttributeGroups[project],
      ...groups,
    }
  }
});

export const saveExpandedSettingGroups = (groups: Record<string, boolean>) => updateClientState({ expandedSettingGroups: groups });

export const setDevelopmentSettingsVisibility = (visible: boolean) => updateClientState({ developmentSettingsVisibility: visible });

export const saveImplicitProjectThumbnails = (project: string, setting: ImplicitProjectThumbnails) => updateClientState(
  {
    ImplicitProjectThumbnails: {
      [project]: {
        ...store.getState().authentication.clientState.ImplicitProjectThumbnails[project],
        ...setting,
      }
    }
  }
);

export const saveLastProjectUpdateTab = (tab: string) => updateClientState({ lastProjectUpdateTab: tab });

export const saveLastProjectUpdateModelsSorting = (s: ModelsSorting) => updateClientState({ lastProjectUpdateModelsSorting: s });

export const saveLastProjectUpdateMembersSorting = (s: MembersSorting) => updateClientState({ lastProjectUpdateMembersSorting: s });
